import { SET_COMPANIES, SET_COMPANY } from '@actions/company'

const defaultState = {
  companies: null,
  total: 0,
  company: null
}

const companyReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_COMPANIES: {
      const { data } = action
      return {
        ...state,
        companies: data.list,
        total: data.total,
      }
    }
    case SET_COMPANY: {
      const { data } = action
      return {
        ...state,
        company: data,
      }
    }
    default:
      return state
  }
}

export default companyReducer
